import React, {useEffect} from 'react';
import { useDispatch } from 'react-redux';
import { loginUserData, savePhone } from '../redux/loginSlice';

function HeaderTop() {
  const dispatch = useDispatch();

  useEffect(()=>{
    localStorage.removeItem('userToken')
    localStorage.removeItem('userToken')
    dispatch(loginUserData(null))
    dispatch(savePhone(null))
  })

  // Header is now handled by the navbar in Sidebar.jsx
  // This component just handles the auth cleanup logic
  return null;
}

export default HeaderTop;
